import clsx from 'clsx';

import { ExcelFileIcon } from '../../../icons';

import { Field, IField } from './Field';
import { ILinkActionProps, LinkAction } from './LinkAction';

export interface IBodySectionOptions {
  csvLink?: Omit<ILinkActionProps, 'IconStart'>;
  fields: IField[];
  source: 'user-active' | 'user-other';
}

interface IBodySectionProps extends IBodySectionOptions {}

/**
 * -----------------------------------------------------------------------------
 * It renders a body section with a record details and a link action
 */
export function BodySection({
  csvLink,
  fields,
  source,
}: Readonly<IBodySectionProps>) {
  return (
    <div
      className={clsx(
        'border-b border-t px-4 py-1.5',
        source === 'user-active' ? 'border-gray-50' : 'border-transparent'
      )}
    >
      <div className="flex flex-col items-start gap-6 md:flex-row md:items-center">
        <div className="grid grow grid-cols-1 gap-3 sm:gap-1 md:grid-cols-2">
          {fields.map(({ id, variant }) => (
            <Field key={id} variant={variant} />
          ))}
        </div>

        {csvLink ? <LinkAction {...csvLink} IconStart={ExcelFileIcon} /> : null}
      </div>
    </div>
  );
}
